import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import api from "../api/client";

interface UseIsAdminResult {
  isAdmin: boolean;
  loading: boolean;
}

const fetchAdminMe = async (): Promise<boolean> => {
  try {
    const res = await api.get("/platform-admin/me");
    return res.data?.is_admin === true;
  } catch {
    return false;
  }
};

export function useIsAdmin(): UseIsAdminResult {
  const { currentUser, initializing } = useAuth();

  const { data: isAdmin = false, isLoading } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: fetchAdminMe,
    enabled: !initializing && !!currentUser,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return { isAdmin, loading: initializing || isLoading };
}
